import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { iif, of } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  filter,
  switchMap
} from 'rxjs/operators';
import { StatusTrackerFacadeService } from '../../facades/status-tracker/status-tracker-facade.service';
import {
  FutureActivityDisabled,
  FutureActivityRequest
} from '../../models/future-activites/future-activites.interfaces';
import { FutureActivityService } from '../../services/status-tracker/future-activities.service';
import {
  loadFutureActivity,
  loadFutureActivityFailure,
  loadFutureActivitySuccess
} from '../actions/status-tracker.actions';

@Injectable()
export class FutureActivityEffects {
  loadActivityData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadFutureActivity),
      switchMap(() =>
        this.statusTracker.futureActivityRequest$.pipe(
          distinctUntilChanged(
            (previous, current) =>
              JSON.stringify(previous) === JSON.stringify(current)
          ),
          filter((payload) => Object.keys(payload).length > 0),
          switchMap((payload) =>
            iif(
              () => 'disabled' in payload,
              of(
                loadFutureActivitySuccess({
                  futureActivities: {
                    id: 'future-activity-content',
                    futureActivityContent: payload as FutureActivityDisabled
                  }
                })
              ),
              this.futureActivity
                .getFutureActivities(payload as FutureActivityRequest)
                .pipe(
                  filter((content) => !!content),
                  switchMap((content) => [
                    loadFutureActivitySuccess({
                      futureActivities: {
                        id: 'future-activity-content',
                        futureActivityContent: content
                      }
                    })
                  ])
                )
            )
          )
        )
      ),
      catchError(() =>
        of(
          loadFutureActivityFailure({
            error: {
              id: 'future-activity-content-error',
              futureActivityContentError: 'future-activity'
            }
          })
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly futureActivity: FutureActivityService,
    private readonly statusTracker: StatusTrackerFacadeService
  ) {}
}
